export default __webpack_public_path__ + "static/realWorldImg3-a28d1296241e40161b8e8f81c8dfd5a7.png";